<div style="width: 95%;" [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
    <div mat-dialog-title class="modal-header-bg d-flex justify-content-end px-3 pt-1"></div>
    <div mat-dialog-content>
      <h4 class="font-weight-bold title-text custom">
        {{ "request-stock" | translate }}
        <img src="assets/img/ReserveShares.svg" alt="Stock Request" class="withdraw-icon">
      </h4>
      <p class="text-muted-special subtitle-text">{{ "request-stock-subtitle" | translate }}</p>
  
      <div class="settings-profile">
        <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
          <div class="overlay-content">
            {{ "choose-account" | translate }}
          </div>
        </div> -->
        <form #reqStockForm="ngForm" (ngSubmit)="submitReqStock(reqStockForm)">
          <div class="form-row"> 
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{ "accounts" | translate }}</label>
              <ng-select [formControl]="selectedAccountControl" (ngModelChange)="onAccountChange($event)" [searchable]="false" class="custom" ngModel name="RelationCode" [dropdownPosition]="'bottom'" required [placeholder]="'accounts' | translate">
                      <ng-template ng-label-tmp let-item="selectedAccount">
                        <span *ngIf="translate.currentLang === 'en'">
                          {{ selectedAccount.clientNameEn }} — {{ (selectedAccount.accountTypeEn )}}
                        </span>
                        <span *ngIf="translate.currentLang === 'ar'" class="option-ar">
                          <span>{{ selectedAccount.clientNameAr }}</span> -
                          <span>({{ selectedAccount.accountTypeAr }})</span>
                        </span>
                      </ng-template>
                <ng-option *ngFor="let Acc of userAccounts" [value]="Acc.relationCode">
                       <span *ngIf="translate.currentLang === 'en'">
                          {{ Acc.clientNameEn }} — {{ Acc.accountTypeEn }}
                        </span>

                        <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                          <span>{{ Acc.clientNameAr }}</span>
                          <span>{{ Acc.accountTypeAr }}</span>
                        </span>                </ng-option>
              </ng-select>
            </div>
            <div class="col-md-6">
              <label class="required form-field-title">{{ "stock" | translate }}</label>
              <ng-select
                [searchable]="true"
                class="custom"
                ngModel
                #SymbolCode="ngModel"
                name="SymbolCode"
                required
                [dropdownPosition]="'bottom'"
              >
                <ng-option *ngFor="let Symbol of allstocks" [value]="Symbol">
                  ({{ Symbol.ReutersCode }})
                  {{
                    translate.currentLang == "en"
                      ? Symbol.ShortNameE
                      : Symbol.ShortNameA
                  }}
                </ng-option>
              </ng-select>
            </div>
  
            <div class="col-md-6">
              <label class="required form-field-title">{{ "custodian" | translate }}</label>
              <ng-select
                [searchable]="true"
                class="custom"
                ngModel
                #CustodianCode="ngModel"
                name="CustodianCode"
                required
                [dropdownPosition]="'bottom'"
              >
                <ng-option *ngFor="let Custodian of allCustod" [value]="Custodian">
                  ({{ Custodian.CustodianCode }})
                  {{
                    translate.currentLang == "en"
                      ? Custodian.CustodianNameE
                      : Custodian.CustodianNameA
                  }}
                </ng-option>
              </ng-select>
            </div>
  
            <div class="col-md-6">
              <label class="required form-field-title">{{ "qty" | translate }}</label>
              <input
                ngModel
                #Qty="ngModel"
                (keypress)="noDecimal($event)"
                oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';"
                min="1"
                name="Qty"
                type="text"
                class="form-control"
                required
                appInputCommaSepreated
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
              />
            </div>
  
            <div class="col-md-6">
              <label class="required form-field-title">{{ "cost-price" | translate }}</label>
              <input
                class="form-control"
                [ngClass]="translate.currentLang == 'en' ? 'number-input' : 'number-input-ar'"
                id="CostPrice"
                #CostPrice="ngModel"
                name="CostPrice"
                ngModel
                min="1"
                type="text"
                required
                appTwoDigitDecimalNumber="true"
                appInputCommaSepreated
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
              />
              <div *ngIf="CostPrice.touched && CostPrice.invalid" class="red">
                <span *ngIf="CostPrice.errors.required">{{ "amount-num-err" | translate }}</span>
                <span *ngIf="CostPrice.errors.pattern">{{ "amount-decimal-err" | translate }}</span>
              </div>
            </div>
  
            <div class="col-md-6 d-flex justify-content-end">
              <button
                class="btn btn-primary align-self-center mt-4"
                type="submit"
                [disabled]="reqStockForm.invalid || isSubmitting || !selectedAccount"
              >
                <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                {{ "add-stock" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  